import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../store/extensions';

const VisualizerWidthListItem = (props) => {
    const { visualizerWidth, updateVisualizerSettings, maxVisualizerWidth } = props;
    
    const onWidthChange = (value) => {
        previewHistoryBatch.start();
        updateVisualizerSettings({ width: value });
    };
    
    return (
        <SliderListItem
            title='Width'
            value={visualizerWidth}
            displayMultiplier={1}
            min={0}
            max={maxVisualizerWidth}
            step={1}
            onValueChange={onWidthChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { width: visualizerWidth } = state.createPreview.present.videoSettings.visualizer;
    const { maxVisualizerWidth } = state.create.maxValues;

    return { 
        visualizerWidth,
        maxVisualizerWidth
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerWidthListItem);